module.exports = __webpack_public_path__ + "img/product01.ca3ec1d0.png";